// extracted by mini-css-extract-plugin
export default {"titleContainer":"title_titleContainer__zo3kk","back":"title_back__BHNN4","title":"title_title__QcYjl","subtitle":"title_subtitle__LQiZ4","content":"title_content__uzuZN"};